<div class="main-content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <p-toolbar styleClass="p-mb-4">
                        <ng-template pTemplate="left">
                            <span class="p-input-icon-left">
                                    <i class="pi pi-search"></i>
                                    <input pInputText type="text" [(ngModel)]="nameToSearch" (keyup)="searchPartner()"/>
                            </span>
                        </ng-template>
                        <ng-template pTemplate="right">
                            <button pButton pRipple label="{{ 'PARTNER.ADD_NEW' | translate }}" icon="pi pi-plus"
                                    class="p-button-success mr-2 njoyButton"
                                    (click)="addNew()"></button>
                        </ng-template>
                    </p-toolbar>
                    <p-table #dt [value]="partners"
                             [rows]="10"
                             [first]="first"
                             [totalRecords]="totalRecords"
                             (onPage)="onLazyLoad($event)"
                             [paginator]="true"
                             [lazy]="true"
                             [rowHover]="true"
                             [showCurrentPageReport]="true"
                             [rowsPerPageOptions]="[10,25,50]">
                        <ng-template pTemplate="header">
                            <tr>
                                <th>{{ 'CLIENT.LASTNAME_LABEL' | translate }}</th>
                                <th>{{ 'PARTNER.IMAGE_LABEL' | translate }}</th>
                                <th>{{ 'PARTNER.QR_CODE_LABEL' | translate }}</th>
                                <th>{{ 'PARTNER.CATEGORY_LABEL' | translate }}</th>
                                <th>{{ 'PARTNER.COUP_DE_COEUR' | translate }}</th>
                                <th>{{ 'PARTNER.POPULAR' | translate }}</th>
                                <th>{{ 'PARTNER.IS_DRAFT' | translate }}</th>
                                <th></th>
                                <th></th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-partner let-i="rowIndex">
                            <tr (dblclick)="selectPartner(partner)">
                                <td>{{partner?.name}}</td>
                                <td>
                                    <div class="logo-container" *ngIf="partner.imagePath">
                                        <img [src]="partner?.imagePath" class="small-logo"/>
                                        <span class="logo-tooltip">
                                            <img [src]="partner?.imagePath" class="middle-logo"/>
                                        </span>
                                    </div>
                                    <img src="assets/icons/shared/image-not-found.png" alt="" class="small-logo"
                                         *ngIf="!partner.imagePath">
                                </td>
                                <td>
                                    <div class="logo-container" *ngIf="partner.qrCodePath">
                                        <img [src]="partner?.qrCodePath" class="small-logo"/>
                                        <span class="logo-tooltip">
                                            <img [src]="partner?.qrCodePath" class="middle-logo"/>
                                        </span>
                                    </div>
                                    <img src="assets/icons/shared/image-not-found.png" alt="" class="small-logo"
                                         *ngIf="!partner.qrCodePath">
                                </td>
                                <td>{{partner?.categoryName}}</td>
                                <td>
                                    <i class="pi pi-check" *ngIf="partner.heartStroke"></i>
                                </td>
                                <td>
                                    <i class="pi pi-check" *ngIf="partner.popular"></i>
                                </td>
                                <td>
                                    <i class="pi pi-check" *ngIf="partner.draft"></i>
                                </td>
                                <td (click)="$event.stopPropagation();"><a
                                        href="/partners/{{partner.uuid}}">{{ 'COMMON.DETAILS' | translate }}</a>
                                </td>
                                <td>
                                    <button pButton pRipple icon="pi pi-times" class="p-button-rounded njoyButton"
                                            (click)="confirmDeletePartner(partner)"></button>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </div>
        </div>
    </div>
</div>
<p-dialog *ngIf="addNewPartnerDialog" [(visible)]="addNewPartnerDialog" [style]="{width: '600px'}"
          [header]="modalTitle" [modal]="true"
          styleClass="p-fluid">

    <div class="container-fluid">
        <form [formGroup]="partnerForm">
            <div class="row">
                <div class="col-md-4 mt-4">
                    <mat-label>{{ 'CATEGORY.LABEL' | translate }} *</mat-label>
                </div>
                <div class="col-md-8">
                    <mat-form-field class="example-full-width">
                        <input matInput formControlName="name"
                               [errorStateMatcher]="matcher" type="text">
                        <mat-error *ngIf="getControl?.name?.errors?.required">
                            {{ 'CLIENT.LASTNAME_REQUIRED_ERROR_LABEL' | translate }}
                            <strong>{{ 'COMMON.REQUIRED_MALE' | translate }}</strong>
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 mt-5">
                    <mat-label>{{ 'CATEGORY.BACKGROUND_IMAGE' | translate }} *</mat-label>
                </div>
                <div class="col-md-8" *ngIf="!displayImage">
                    <p-fileUpload #fileUpload (onSelect)="onUpload($event)" (onClear)="clearFile()"
                                  (onRemove)="clearFile()"
                                  [showUploadButton]="false"
                                  accept="image/*">
                    </p-fileUpload>
                    <mat-error style="font-size: 75%;" *ngIf="noFileUploaded">
                        {{ 'PARTNER.IMAGE_REQUIRED_LABEL' | translate }}
                        <strong>{{ 'COMMON.REQUIRED_FEMALE' | translate }}</strong>
                    </mat-error>
                </div>
                <div class="col-md-8" *ngIf="displayImage">
                            <span class="logo-tooltip" (click)="changeImageValue()">
                                <img [src]="selectedPartner?.imagePath" class="middle-logo"/>
                            </span>
                </div>
            </div>
            <div class="row mt-4">
                <div class="col-md-4 mt-2">
                    <mat-label>{{ 'CLIENT.ADDRESS_LABEL' | translate }}*</mat-label>
                </div>
                <div class="col-md-8">
                    <mat-form-field class="example-full-width">
                        <input matInput formControlName="streetAddress"
                               [errorStateMatcher]="matcher" type="text">
                        <mat-error *ngIf="getControl?.streetAddress?.errors?.required">
                            {{ 'PARTNER.ADDRESS_REQUIRED_ERROR_LABEL' | translate }}
                            <strong>{{ 'COMMON.REQUIRED_FEMALE' | translate }}</strong>
                        </mat-error>
                    </mat-form-field>
                    <mat-error style="font-size: 75%;" *ngIf="addressNotFound">
                        {{ 'PARTNER.ADDRESS_NOT_FOUND_ERROR' | translate }}
                    </mat-error>
                </div>
            </div>
            <div class="row">
                <div class="col-md-2 mt-3">
                    <mat-label>{{ 'CLIENT.CITY_LABEL' | translate }}*</mat-label>
                </div>
                <div class="col-md-3 mr-3">
                    <mat-form-field class="example-full-width">
                        <input matInput formControlName="city"
                               [errorStateMatcher]="matcher" type="text">
                        <mat-error *ngIf="getControl?.city?.errors?.required">
                            {{ 'PARTNER.CITY_REQUIRED_ERROR_LABEL' | translate }}
                            <strong>{{ 'COMMON.REQUIRED_FEMALE' | translate }}</strong>
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-2.5 mt-3">
                    <mat-label>{{ 'CLIENT.ZIPCODE_LABEL' | translate }}*</mat-label>
                </div>
                <div class="col-md-3">
                    <mat-form-field class="example-full-width">
                        <input matInput formControlName="zipCode"
                               [errorStateMatcher]="matcher" type="text">
                        <mat-error *ngIf="getControl?.zipCode?.errors?.required">
                            {{ 'PARTNER.ZIPCODE_REQUIRED_ERROR_LABEL' | translate }}
                            <strong>{{ 'COMMON.REQUIRED_MALE' | translate }}</strong>
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row mt-4">
                <div class="col-md-4 mt-2">
                    <mat-label>{{ 'PARTNER.DESCRIPTION_LABEL' | translate }}*</mat-label>
                </div>
                <div class="col-md-8">
                    <mat-form-field class="example-full-width">
                        <textarea matInput formControlName="description" (ngModelChange)="setRemainingCharsValue()" rows="5"></textarea>
                        <span class="remaning">{{remainingText}}</span>
                        <mat-error *ngIf="getControl?.description?.errors?.required">
                            {{ 'PARTNER.DESCRIPTION_REQUIRED_ERROR_LABEL' | translate }}
                            <strong>{{ 'COMMON.REQUIRED_FEMALE' | translate }}</strong>
                        </mat-error>
                        <mat-error *ngIf="getControl?.description?.errors?.maxlength">
                            {{ 'PARTNER.DESCRIPTION_MAX_LENGTH_ERROR_LABEL' | translate }}
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
        </form>
        <div>
            <div class="row mt-4">
                <div class="col-md-4 mt-2">
                    <mat-label>{{ 'PARTNER.CATEGORY_LABEL' | translate }}*</mat-label>
                </div>
                <div class="col-md-8">
                    <p-dropdown [appendTo]="'body'" [options]="categories" [(ngModel)]="selectedCategory"
                                optionLabel="label"
                                (onChange)="changeSelectedCategory($event)"></p-dropdown>
                </div>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-md-4 mt-2">
                <mat-label>{{ 'PARTNER.COUP_DE_COEUR' | translate }}</mat-label>
            </div>
            <div class="col-md-8">
                <p-checkbox [(ngModel)]="partnerHeartStroke"
                            [binary]="true"></p-checkbox>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-md-4 mt-2">
                <mat-label>{{ 'PARTNER.POPULAR' | translate }}</mat-label>
            </div>
            <div class="col-md-8">
                <p-checkbox [(ngModel)]="partnerPopular"
                            [binary]="true"></p-checkbox>
            </div>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <button pButton pRipple label="{{ 'BUTTONS.SAVE' | translate }}" icon="pi pi-check" class="p-button-text"
                (click)="addOrUpdatePartner()"></button>
    </ng-template>
</p-dialog>
<p-toast></p-toast>

<p-confirmDialog #cd header="Confirmation"
                 icon="pi pi-exclamation-triangle"
                 acceptLabel="{{ 'BUTTONS.YES' | translate }}"
                 rejectLabel="{{ 'BUTTONS.NO' | translate }}"
>
    <ng-template pTemplate="footer">
        <button type="button" pButton icon="pi pi-check" label="Yes" (click)="cd.accept()"></button>
        <button type="button" pButton icon="pi pi-times" label="No" (click)="cd.reject()"></button>
    </ng-template>
</p-confirmDialog>
